import { die } from './belt.js';
import { bytes } from './data.js';
export const bytes_to_stream = (atu8) => new Response(atu8).body;
export const pipe_bytes_through = (atu8, d_pair) => bytes_to_stream(atu8).pipeThrough(d_pair);
export const stream_to_bytes = async (d_stream) => bytes(await new Response(d_stream).arrayBuffer());
const transcompress_bytes_gzip = (atu8, d_stream) => stream_to_bytes(pipe_bytes_through(atu8, new d_stream('gzip')));
export const [gzip_bytes, gunzip_bytes] = (typeof CompressionStream > 't'
    ? typeof Bun > 't'
        ? die('gzip (de)compression not available in current environment')
        : [
            Bun.gzipSync,
            Bun.gunzipSync,
        ]
    : [
        (atu8) => transcompress_bytes_gzip(atu8, CompressionStream),
        (atu8) => transcompress_bytes_gzip(atu8, DecompressionStream),
    ]);
//# sourceMappingURL=compression.js.map